import { render, staticRenderFns } from "./templateTag.vue?vue&type=template&id=45b5a946&scoped=true&"
import script from "./templateTag.vue?vue&type=script&lang=js&"
export * from "./templateTag.vue?vue&type=script&lang=js&"
import style0 from "./templateTag.vue?vue&type=style&index=0&lang=less&"
import style1 from "./templateTag.vue?vue&type=style&index=1&id=45b5a946&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b5a946",
  null
  
)

export default component.exports